import "./App.scss";
import AddAnnouncement from "./pages/AddAnnouncement/AddAnnouncement";

import AddSpares from "./pages/AddSpares/AddSpares";
import CarDetails from "./pages/CarDetails/CarDetails";
import CategoryPage from "./pages/CategoryPage/CategoryPage";

import Home from "./pages/Home/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MyAccount from "./pages/MyAccount/MyAccount";
import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";
import ActivateAccount from "./pages/ActivateAccount/ActivateAccount";
import UpdateCar from "./pages/UpdateCar/UpdateCar";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import SetNewPassword from "./pages/SetNewPassword/SetNewPassword";
import ResendOTP from "./pages/ResendOtp/ResendOtp";
import MySpares from "./pages/MySpares/MySpares";
import SpareDetails from "./pages/SpareDetails/SpareDetails";
import UpdateSpare from "./pages/UpdateSpare/UpdateSpare";
import UpdateUser from "./pages/UpdateUser/UpdateUser";

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/car/:id' element={<CarDetails />} />
          <Route path='/spare/:id' element={<SpareDetails />} />
          <Route path='/category/:id' element={<CategoryPage />} />
          <Route path='/addAnnoucement' element={<AddAnnouncement />} />
          <Route path='/addSpares' element={<AddSpares />} />
          <Route path='/myAccount' element={<MyAccount />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/activateAccount' element={<ActivateAccount />} />
          <Route path='/updateCar/:id' element={<UpdateCar />} />
          <Route path='/resetPassword' element={<ResetPassword />} />
          <Route path='/updateSpare/:id' element={<UpdateSpare />} />
          <Route path='/setNewPassword' element={<SetNewPassword />} />
          <Route path='/resendOtp' element={<ResendOTP />} />
          <Route path='/mySpares' element={<MySpares />} />
          <Route path='/updateUser' element={<UpdateUser />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
